import React from 'react';
import { Helmet } from 'react-helmet';

function About() {
  const teamMembers = [
    {
      id: 1,
      name: 'Μαρία Παπαδοπούλου',
      position: 'Εκτελεστική Σεφ',
      bio: 'Με πάνω από 15 χρόνια εμπειρίας στην υψηλή κουζίνα, η Μαρία φέρνει καινοτομία και πάθος σε κάθε πιάτο. Έχει εκπαιδευτεί στα καλύτερα εστιατόρια της Ευρώπης.',
      image: '/images/team_1.jpg'
    },
    {
      id: 2,
      name: 'Ελένη Κωνσταντίνου',
      position: 'Διευθύντρια Εκδηλώσεων',
      bio: 'Η Ελένη είναι η μαέστρος του σχεδιασμού εκδηλώσεων με ειδίκευση σε εταιρικά events. Φροντίζει κάθε λεπτομέρεια για να εξασφαλίσει την τελειότητα.',
      image: '/images/team_2.jpg'
    },
    {
      id: 3,
      name: 'Νίκος Αντωνίου',
      position: 'Σεφ Ζαχαροπλαστικής',
      bio: 'Ο Νίκος δημιουργεί γλυκά έργα τέχνης που συνδυάζουν την παραδοσιακή τεχνική με μοντέρνες παρουσιάσεις. Κάθε του δημιούργημα είναι μοναδικό.',
      image: '/images/team_3.jpg'
    },
    {
      id: 4,
      name: 'Σοφία Μιχαηλίδου',
      position: 'Διαχειρίστρια Ποιότητας',
      bio: 'Η Σοφία διασφαλίζει ότι κάθε προϊόν που χρησιμοποιούμε πληροί τα υψηλότερα standards ποιότητας. Είναι πιστοποιημένη διαιτολόγος και ειδικός σε οργανικά τρόφιμα.',
      image: '/images/team_4.jpg'
    },
    {
      id: 5,
      name: 'Δημήτρης Γεωργίου',
      position: 'Επικεφαλής Sous Chef',
      bio: 'Ο Δημήτρης είναι η δύναμη πίσω από τη λειτουργία της κουζίνας μας. Με την οργανωτική του ικανότητα και την τεχνική του γνώση, κάθε service τρέχει ομαλά.',
      image: '/images/team_5.jpg'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Σχετικά με το Nalumer | Η Ομάδα Catering μας</title>
        <meta name="description" content="Γνωρίστε την ομάδα του Nalumer: σεφ, διοργανωτές και ειδικοί ποιότητας με πάθος για γαστρονομία και άψογη διοργάνωση κάθε εκδήλωσης στην Ελλάδα." />
        <meta property="og:title" content="Σχετικά με το Nalumer | Η Ομάδα Catering μας" />
        <meta property="og:description" content="Γνωρίστε την ομάδα του Nalumer: σεφ, διοργανωτές και ειδικοί ποιότητας με πάθος για γαστρονομία και άψογη διοργάνωση κάθε εκδήλωσης στην Ελλάδα." />
        <link rel="canonical" href="https://nalumer.com/about" />
      </Helmet>

      <div className="about-container">
        <div className="about-hero">
          <h1>Η Ιστορία μας</h1>
          <p>
            Το Nalumer ξεκίνησε το 2015 από ένα όνειρο: να φέρουμε την υψηλή γαστρονομία σε κάθε εκδήλωση. Σήμερα, είμαστε μία από τις πιο αξιόπιστες υπηρεσίες catering στην περιοχή, με εκατοντάδες επιτυχημένες εκδηλώσεις και χιλιάδες ευχαριστημένους πελάτες.
          </p>
        </div>

        <section className="about-blog-section">
          <h2>Η Φιλοσοφία μας</h2>
          <p>
            Στο Nalumer πιστεύουμε ότι το φαγητό είναι περισσότερο από απλή τροφή. Είναι μια εμπειρία που ενώνει ανθρώπους, δημιουργεί αναμνήσεις και εκφράζει συναισθήματα. Γι αυτό προσεγγίζουμε κάθε εκδήλωση με την ίδια φροντίδα και προσοχή, ανεξάρτητα από το μέγεθός της.
          </p>
          <p>
            Η δέσμευσή μας στην ποιότητα ξεκινά από την προμήθεια των καλύτερων υλικών. Συνεργαζόμαστε με τοπικούς παραγωγούς για φρέσκα λαχανικά, κρέας από ελεύθερης βοσκής ζώα και βιολογικά προϊόντα. Κάθε συστατικό επιλέγεται με μέριμνα για να εξασφαλίσουμε όχι μόνο την εξαιρετική γεύση αλλά και τη διατροφική αξία.
          </p>
          <p>
            Η καινοτομία είναι στο DNA μας. Παρακολουθούμε τις τελευταίες τάσεις στη γαστρονομία και τις προσαρμόζουμε στις ανάγκες των πελατών μας. Από μοριακή κουζίνα μέχρι παραδοσιακές συνταγές με σύγχρονη ματιά, η δημιουργικότητά μας δεν έχει όρια.
          </p>
        </section>

        <section className="team-section">
          <h2>Η Ομάδα μας</h2>
          <div className="team-grid">
            {teamMembers.map((member) => (
              <div key={member.id} className="team-member">
                <img 
                  src={member.image} 
                  alt={member.name}
                  width="400"
                  height="400"
                />
                <h3>{member.name}</h3>
                <h4>{member.position}</h4>
                <p>{member.bio}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="about-blog-section">
          <h2>Οι Αξίες μας</h2>
          <ul className="custom-list">
            <li>Ποιότητα χωρίς συμβιβασμούς σε κάθε πιάτο που δημιουργούμε</li>
            <li>Σεβασμός στο περιβάλλον και υποστήριξη βιώσιμων πρακτικών</li>
            <li>Καινοτομία και συνεχής βελτίωση των υπηρεσιών μας</li>
            <li>Εξατομικευμένη προσέγγιση για κάθε πελάτη</li>
            <li>Επαγγελματισμός και αφοσίωση σε κάθε λεπτομέρεια</li>
          </ul>
        </section>

        <div className="timeline-section">
          <h3>Η Πορεία μας</h3>
          <div className="timeline">
            <div className="timeline-item">
              <h4>2015 - Η Αρχή</h4>
              <p>Ίδρυση της εταιρείας με ένα μικρό γραφείο και ένα όνειρο για εξαιρετικό catering</p>
            </div>
            <div className="timeline-item">
              <h4>2017 - Επέκταση</h4>
              <p>Άνοιγμα της δικής μας κουζίνας και πρόσληψη επαγγελματικής ομάδας</p>
            </div>
            <div className="timeline-item">
              <h4>2019 - Αναγνώριση</h4>
              <p>Βραβείο Best Catering Service από την Εθνική Ένωση Εστιατόρων</p>
            </div>
            <div className="timeline-item">
              <h4>2021 - Καινοτομία</h4>
              <p>Εισαγωγή βιολογικού μενού και βιώσιμων πρακτικών στις υπηρεσίες μας</p>
            </div>
            <div className="timeline-item">
              <h4>2025 - Σήμερα</h4>
              <p>Κορυφαία υπηρεσία catering με 500+ επιτυχημένες εκδηλώσεις ετησίως</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;